import { TileBigNumber } from '@/features/Dashboard/types';

/**
 * Type representing an active symbol for chart/widget configuration
 */
export type ActiveSymbol = {
  id: string;
  shortTitle: string;
  symbol: {
    Code: string;
    PeriodType: string;
    Period: string;
    TimeRef: string;
  };
  group: 'Prod_Indexes';
};

/**
 * Converts an array of tiles to active symbols for chart/widget configuration.
 * Takes the first N tiles (up to maxCount) and transforms them into the format
 * expected by the chart app context.
 *
 * @param tiles - Array of tiles to convert
 * @param maxCount - Maximum number of tiles to convert (default: 8)
 * @returns Array of active symbols ready for chart/widget configuration
 */
export const convertTilesToActiveSymbols = (
  tiles: TileBigNumber[],
  maxCount = 8
): ActiveSymbol[] => {
  return tiles.slice(0, maxCount).map(t => ({
    id: t.id,
    shortTitle: t.shortTitle,
    symbol: {
      Code: t.symbol.key.Code,
      PeriodType: t.symbol.key.PeriodType,
      Period: t.symbol.key.Period,
      TimeRef: t.symbol.key.TimeRef
    },
    group: 'Prod_Indexes' as const
  }));
};
